export const ADD_VEHICLE = 'ADD_VEHICLE'
export const REMOVE_VEHICLE_BY_ID = 'REMOVE_VEHICLE_BY_ID'
export const SET_RAW_VEHICLE_DATA = 'SET_RAW_VEHICLE_DATA'
